<template>
    <div class="dashboard">

        <SideNav v-bind:page_active="page_active" />

        <div class="main-section">

            <TopNav />

            <div class="content-body">
                <div class="row breadcrumb-area">
                    <div class="col-lg-6">
                        <h6><a href="/profile" title="Go back to profile"><i class="fa fa-arrow-left text-dark"></i></a> &nbsp;&nbsp;&nbsp;&nbsp;  <b>Add Delivery Address</b></h6>
                    </div>

                    <div class="col-lg-6">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><a href="/dashboard">Dashboard</a></li>
                                <li class="breadcrumb-item"><a href="/profile">Profile</a></li>
                                <li class="breadcrumb-item active" aria-current="page">Add Address</li>
                            </ol>
                        </nav>                   
                    </div>
                </div>

                <div class="row mt-3">
                    <div class="col">
                        <div class="card">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-lg-5 form-cover mb-5">
                                        <p>Please fill the information to apply for delivery address changes.</p>
                                        
                                        <form  class="login-form" autocomplete="off" method="post">
                                            <div class="form-group">
                                                <!-- <label>Name</label> -->
                                                <b>State:</b>
                                                
                                                <select class="select form-control">
                                                    <option>Lagos</option>
                                                    <option>Oyo</option>
                                                </select>
                                            </div>

                                            
                                            <div class="form-group">
                                                <!-- <label>Phone Number</label> -->
                                                <b>LGA:</b>
                                                <select class="select form-control">
                                                    <option>Kosofe</option>
                                                    <option>Agege</option>
                                                </select>
                                            </div>

                                            <div class="form-group">
                                                <!-- <label>Email</label> -->
                                                <b>Address:</b>
                                                <textarea type="email" class="form-control textarea" placeholder="Type here" required ></textarea>
                                            </div>

                                            <div :class="msg_status" v-html="msg_content"></div>

                                            <button type="submit" class="btn form-control login-btn">ADD SELF-COLLECTION LOCATION</button>

                                        </form>
                                    </div>

                                    <div class="col-lg-3 text-center offset-lg-4 mt-3">
                                    </div>
                                </div>
                            </div>                        
                        </div>                    
                    </div>
                </div>


 
                <Copyright />
            </div>
        </div>
    </div>
</template>




<script>
import SideNav from '@/components/SideNav.vue';
import Copyright from '@/components/Copyright.vue';
import TopNav from '@/components/TopNav.vue';


export default {
    name: "AddLocation",
    components: {
        SideNav, TopNav, Copyright
    },
    
    data() {
        return{
            "page_active": "profile"

        }
    },

    watch: {
        $route: {
            immediate: true,
            handler() {
                document.title = "FMN | Add Location";
            },
        },
    },

    mounted () {   
        this.inactivityTime();      
        this.renderChart(this.chartdata, this.options)
    },

    methods: {

    },

    created () {
    }
};
</script>

<style scoped>
.login-form input.form-control, .textarea, .select {
    margin: 0px 0px 24px;
    font-size: 12px;
}
.login-form .form-group i {
    top: 32px;
}

.login-btn{
    font-size: 12px;
}
</style>

